import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<
  Theme,
  { colors: any; active?: boolean; isClicked?: boolean }
>((theme) => ({
  dropdown: {
    position: 'absolute',
    top: 67,
    left: 0,
    width: '100%',
    height: 'auto',
    backgroundColor: (props) => props.colors.colorBackground,
    zIndex: 5,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  iconNavBar: {
    marginRight: 10,
  },
  boxLink: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 215,
    width: 'auto',
  },
  links: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 700,
    color: (props) =>
      props.active || props.isClicked
        ? props.colors.textAccentColor
        : props.colors.accentColor,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: '#fff',
      cursor: 'pointer',
    },
    '&:focus-visible': {
      outline: '2px solid #005fcc',
      outlineOffset: 2,
    },
  },
  sessionOptions: {
    maxWidth: '1320px',
    width: '100%',
    margin: '15px 0px',
    height: 280,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'start',
    flexWrap: 'wrap',
  },
  textLink: {
    fontFamily: 'Roboto',
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 400,
    textDecoration: 'none',
    color: (props) => props.colors.textBodyBack,
    display: 'flex',
    margin: '11px 0px',
    marginLeft: 10,
    marginRight: 15,
    cursor: 'pointer',
  },
  closeButton: {
    marginRight: 8,
    color: (props) => props.colors.textBodyBack,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  menuItem: {
    minHeight: 40,
    '&:focus-visible': {
      outline: '2px solid #005fcc',
      outlineOffset: -2,
    },
  },
}))
